import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { MaterialRadioGroupControl, NullableNumberInput, } from 'console/shared/components/fields';
import { FlagSelectors } from 'console/device-settings/z3k/components/material-utils/flag-selector';
import { ThreewayTap } from 'z3k-config';
import { unpack_validation, } from 'webui/Z3KConfigParser/validation/types';
import { SettingCard } from 'console/device-settings/z3k/components/material-utils/settings-card/card';
import { Control } from 'console/shared/components/fields/control';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card';
export const ThreewayTapSettings = memo(function ThreewayTapSettings(props) {
    const { state, onChangeTabState, validation } = props;
    const { threeway_tap, state_tap } = state;
    const threewayTapValidation = unpack_validation(validation, 'state_tap');
    if (threeway_tap === undefined || state_tap === undefined)
        return null;
    const selectNewWayTap = useCallback((value) => {
        if (threeway_tap === undefined || state_tap === undefined)
            return;
        const is_two_way_tap = value === '1';
        const newThreewayTap = ThreewayTap.setTwoWayTap(threeway_tap, is_two_way_tap);
        const newState_tap = { ...state_tap };
        if (ThreewayTap.isTwoWay(newThreewayTap)) {
            newState_tap.closing_time = 0;
        }
        onChangeTabState({
            threeway_tap: newThreewayTap,
            state_tap: newState_tap,
        });
    }, [threeway_tap, state_tap]);
    const is_two_way = useMemo(() => ThreewayTap.isTwoWay(threeway_tap), [threeway_tap]);
    const is_two_way_state = useMemo(() => (is_two_way ? '1' : '0'), [is_two_way]);
    const threeway_tap_types = useMemo(() => [
        {
            label: 'Трех-ходовой кран',
            help_id: 'threeway_taps_setting_register_crane',
            value: '0',
        },
        {
            label: 'Термоголовка',
            help_id: 'threeway_taps_setting_register_thermal_head',
            value: '1',
        },
    ], []);
    const threeway_flags_bits = useMemo(() => [
        {
            bit: ThreewayTap.Flags.IS_IN_NON_STOP_MODE_FLAG,
            label: 'Не останавливать по достижению времени закрытия',
            help_id: 'threewaytap_setting_register_close_non_stop',
            show: !is_two_way,
        },
        {
            bit: ThreewayTap.Flags.CLOSE_IF_EMERGENCY,
            label: 'Закрывать при неисправности датчика температуры',
            help_id: 'threewaytap_setting_register_close_on_fault',
            show: !is_two_way,
        },
    ], [is_two_way, ThreewayTap]);
    return (_jsxs(SettingCard, { title: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0441\u043C\u0435\u0441\u0438\u0442\u0435\u043B\u044F", children: [_jsx(MaterialRadioGroupControl, { control_values: threeway_tap_types, value: is_two_way_state, onChange: selectNewWayTap }), _jsx(Control, { label: "\u0412\u0440\u0435\u043C\u044F \u0448\u0430\u0433\u0430, \u0441\u0435\u043A", help_id: 'threeway_taps_step_time', validation_result: unpack_validation(threewayTapValidation, 'step_time'), validation_warnings_result: null, value: state_tap.step_time, onChange: (step_time) => {
                    if (state_tap === undefined)
                        return;
                    const newThreewayTap = {
                        ...state_tap,
                        step_time,
                    };
                    onChangeTabState({ state_tap: newThreewayTap });
                }, field: (input_props) => (_jsx(NullableNumberInput, { min: 0, max: 10, step: 0.1, ...input_props })) }), !ThreewayTap.isTwoWay(threeway_tap) && (_jsxs(_Fragment, { children: [_jsx(Control, { label: "\u041F\u0435\u0440\u0438\u043E\u0434 \u0448\u0430\u0433\u0430, \u0441\u0435\u043A", help_id: 'threeway_taps_step_period', validation_result: unpack_validation(threewayTapValidation, 'step_period'), validation_warnings_result: null, value: state_tap.step_period, onChange: (step_period) => {
                            if (state_tap === undefined)
                                return;
                            const newThreewayTap = {
                                ...state_tap,
                                step_period,
                            };
                            onChangeTabState({
                                state_tap: newThreewayTap,
                            });
                        }, field: (input_props) => (_jsx(NullableNumberInput, { min: 10, max: 180, step: 1, ...input_props })) }), _jsx(Control, { label: "\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u043B\u043D\u043E\u0433\u043E \u0437\u0430\u043A\u0440\u044B\u0442\u0438\u044F, \u0441\u0435\u043A", help_id: 'threeway_taps_closing_time', validation_result: unpack_validation(threewayTapValidation, 'closing_time'), validation_warnings_result: null, value: state_tap.closing_time, onChange: (closing_time) => {
                            if (state_tap === undefined)
                                return;
                            const newThreewayTap = {
                                ...state_tap,
                                closing_time,
                            };
                            onChangeTabState({
                                state_tap: newThreewayTap,
                            });
                        }, field: (input_props) => (_jsx(NullableNumberInput, { min: 0, max: 300, step: 0.1, ...input_props })) })] })), _jsx(Control, { label: "\u041F\u0440\u043E\u043F\u043E\u0440\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u044D\u0444\u0444\u0438\u0446\u0438\u0435\u043D\u0442, \u0441\u0435\u043A/\u00BA\u0421", help_id: 'threeway_taps_coefficient', validation_result: unpack_validation(threewayTapValidation, 'coefficient'), validation_warnings_result: null, value: state_tap.coefficient, onChange: (coefficient) => {
                    if (state_tap === undefined)
                        return;
                    const newThreewayTap = {
                        ...state_tap,
                        coefficient,
                    };
                    onChangeTabState({
                        state_tap: newThreewayTap,
                    });
                }, field: (input_props) => (_jsx(NullableNumberInput, { min: 0, max: 3, step: 0.1, ...input_props })) }), _jsx(SettingFullRow, { children: _jsx(FlagSelectors, { bits: threeway_flags_bits, value: threeway_tap.setting_register, onChange: (setting_register) => {
                        const newThreewayTap = {
                            ...threeway_tap,
                            setting_register,
                        };
                        onChangeTabState({
                            threeway_tap: newThreewayTap,
                        });
                    } }) })] }));
});
